<template>
  <div class="box">
    <breadcrumb :breadcrumb="breadcrumb"></breadcrumb>
    <div class="card_wrap">
      <h5>{{ language("orderQuery.title") }}</h5>
      <div class="card">
        <div class="status">
          <status-card
            :dataArr="statusArr"
            labelWidth="130px"
            :title="language('orderQuery.queryStatus')"
          ></status-card>
        </div>
        <div class="ymd">
          <ymd-card :title="language('orderQuery.period')"></ymd-card>
        </div>
        <div class="input">
          <input-card
            :title="language('orderQuery.transaction')"
            :dataArr="inputArr"
            labelPosition="top"
          ></input-card>
        </div>
      </div>
      <div class="tips">{{ language("orderQuery.searchTips") }}</div>
      <div class="button_wrap">
        <el-button type="primary">{{
          language("orderQuery.search")
        }}</el-button>
      </div>
    </div>

    <div class="table_wrap">
      <div class="count">
        {{ language("orderQuery.results") }}: 6
        {{ language("orderQuery.rows") }}
      </div>
      <cc-table
        :loadData="false"
        :config="table"
        :params="params"
        :refeshParams="refeshTable"
        :emptyText="language('orderQuery.emptyText')"
        :showIndex="false"
      ></cc-table>
    </div>
  </div>
</template>
<script>
import breadcrumb from "../../components/breadcrumb";
import statusCard from "../../components/statusCard";
import ymdCard from "../../components/ymdCard";
import inputCard from "../../components/inputCard";

export default {
  components: {
    breadcrumb,
    statusCard,
    ymdCard,
    inputCard,
  },
  data() {
    return {
      breadcrumb: {
        title: this.language("orderQuery.breadcrumbTitle"),
        list: [
          {
            name: this.language("orderQuery.breadcrumbList_1"),
          },
          {
            name: this.language("orderQuery.breadcrumbList_2"),
          },
        ],
      },
      statusArr: [
        {
          title: "Status",
          checkbox: [],
          list: [
            {
              name: "Open",
              apiName: "open",
              value: "open1",
            },
            {
              name: "Closed",
              apiName: "closed",
              value: "closed",
            },
            {
              name: "Cancel",
              apiName: "cancel",
              value: "cancel",
            },
          ],
        },
        {
          title: "Merchant Reply",
          checkbox: [],
          list: [
            {
              name: "Closed",
              apiName: "Closed",
              value: "Closed",
            },
            {
              name: "Processing",
              apiName: "Processing",
              value: "Processing",
            },
            {
              name: "Replied",
              apiName: "Replied",
              value: "Replied",
            },
          ],
        },
      ],

      inputArr: [
        {
          name: "Query ID",
          apiName: "id",
          value: "",
        },
      ],
      params: {},
      refeshTable: -1,
      table: {
        api: "",
        showPager: false,
        columns: [
          {
            prop: "id",
            lable: "ID",
          },
        ],
        buttons: [],
      },
    };
  },
  mounted() {},
};
</script>
<style scoped lang="scss">
.box {
  height: 100%;
}
.card_wrap {
  background: #f7f7f7;
  padding: 20px;
  h5 {
    font-size: $title;
    margin: 10px 0 20px 0;
  }
  .card {
    display: flex;
    flex-wrap: wrap;
    .status {
      flex: 1;
    }
    .ymd {
      padding-right: 20px;
      padding-left: 20px;
      flex: 1;
    }
    .input {
      width: 300px;
      flex: 1;
    }
  }
}
.tips {
  margin-top: 10px;
  font-size: $sbuTitle;
}
.button_wrap {
  margin-top: 20px;
}
.table_wrap {
  margin-top: 50px;
  .count {
    font-size: $sbuTitle;
    margin-bottom: 20px;
    font-weight: 600;
  }
}
</style>